module.exports = __webpack_public_path__ + "assets/img/mall-list-nodata.949fa8f9.png";